module.exports = __webpack_public_path__ + "img/舞台小丑表演.6e49a9d9.png";